<template>
  <div>
    <div class="flex font-normal">
      <zt-icon name="angle-left" />
      <router-link :to="{ name: 'home' }" class="text-zt-dark-500 px-1" data-vs-link="link-to-home">
        {{ $t("message.publishedEforms.go_back_btn") }}
      </router-link>
    </div>
    <div class="text-zt-xl font-normal">
      <h1 class="text-zt-dark-400 text-zt-xl pt-2 pb-4">
        {{ $t("message.publishedEforms.parent_title") }}
      </h1>
      
    </div>
    <div class="card card-style flex h-100 justify-content-center mb-20">
      <div class="text-zt-xl font-normal  flex  justify-content-between">
        <h1 class="px-4 py-4">
          {{ $t("message.publishedEforms.title") }}
        </h1>
        <div class="box-button py-3 px-2">
          <zt-button
            data-vs-button="document-filters"
            @click="filtersContainer = !filtersContainer"
            class="button-filter text-base"
            :class="{
              'button-filter-grey': filtersContainer === true,
            }"
            icon="filter-amount"
            gtmClass="zt-gtm-documents-inbox-filters"
            >{{ $t("message.publishedEforms.filter.title") }}</zt-button
          >
        </div>
      </div>

      <transition name="fade">
        <div class="wrapper-filters w-full flex justify-center text-base">
          <div
            v-show="filtersContainer"
            class=" w-full px-2"
            :class="{
              expanded: filtersContainer === true,
            }"
          >
          
            <template>
              <div class="flex justify-content-between mt-3 mb-3 mx-1">
                <div class="filters flex w-8/12">
                  <div class="w-4/12 pr-3">
                    <template>
                      <div class="w-full">
                        <zt-autocomplete
                          data-vs-autocomplete="document-sender"
                          ref="ztAutocompleteSender"
                          label="Remitente"
                          outlined
                          returnObject
                          :searchCharacter="3"
                          :items="autocompleteListSenders"
                          noResultsText="No hay tareas que coincidan con tu búsqueda"
                          @search="getSenders"
                          @input="autoCompleteOptionSelected"
                          v-model="userSenderSelected"
                        ></zt-autocomplete>
                      </div>
                    </template>
                  </div>
                  <div class="w-4/12 pr-3">
                    <div class="wrap-datepicker">
                      <v-date-picker
                        data-vs-datepicker="range-filters"
                        v-model="dateRangeFilter"
                        is-range
                        mode="date"
                        color="indigo"
                        :locale="localeDatePicker"
                        @input="menuDatePicker = false"
                        @change="(e) => handlerChange(e)"
                        :popover="{ visibility: 'click' }"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <div class="px-2 relative">
                            <zt-input
                              data-vs-input="document-filters-value"
                              v-model="inputValue.end"
                              :value="dateSearchText"
                              label="Rango de fechas"
                              outlined
                              append-icon="date"
                              v-on="inputEvents.end"
                              ref="ztInputCalendar"
                            />
                          </div>
                        </template>
                      </v-date-picker>
                    </div>
                  </div>
                  <div class="w-4/12">
                    <zt-autocomplete
                      data-vs-autocomplete="document-types"
                      ref="ztAutocompleteTypeDocuments"
                      label="Tipo de Documentos"
                      outlined
                      returnObject
                      :searchCharacter="3"
                      :items="autocompleteListTypeDocuments"
                      noResultsText="No hay tareas que coincidan con tu búsqueda"
                      @search="getTypeDocuments"
                      @input="autoCompleteOptionTypeDocumentsSelected"
                      v-model="typeDocumentsSelected"
                    ></zt-autocomplete>
                  </div>
                </div>
                <div class="actions w-4/12 flex justify-content-end">
                  <zt-button outlined text icon="trash-outline" @click="cleanFilters()" class="mr-3" data-vs-button="clear-filters">
                    {{ $t("message.publishedEforms.filter.clear_filter_btn") }}
                  </zt-button >
                  <zt-button @click="getPublishedEformsFilter()" data-vs-button="get-eforms-filters">
                    {{ $t("message.publishedEforms.filter.filter_btn") }}
                  </zt-button>
                </div>
              </div>
            </template>

          </div>
        </div>
      </transition>

      <tableCustom :items="items" @reloaded-now="setReloadedNow" @sorting="setSorting"/>
      <div
        class="flex justify-end py-4"
        v-if="pagination.total > pagination.limit"
      >
        <span class="pr-3 pt-3">
          {{ $t("message.publishedEforms.paginator.rowsByPage") }}
        </span>
        <div class="size-page-result pr-4">
          <select
            data-vs-select="table-per-page"
            v-model="pagination.limit"
            class="form-control m-input select_result_page"
            @change="reloadLimit"
          >
            <option value="10" data-vs-option-value="opt-10">10</option>
            <option value="25" data-vs-option-value="opt-25">25</option>
            <option value="50" data-vs-option-value="opt-50">50</option>
          </select>
        </div>
        <div class="pr-2 pt-3">
          {{pagination.page}} - {{pagination.limit}} {{ $t("message.publishedEforms.paginator.of") }} {{pagination.total}}
        </div>
        <div class="flex pr-3 pl-10 pt-3">
					<div class="pr-5">
						<button
              data-vs-button-="last-page"
              @click="getPage('last')"
              :disabled="pagination.page === 1"
						>
							<zt-icon name="arrow-left-outline" />
						</button>
					</div>
					<div class="pl-2 pr-4">
						<button
              data-vs-button-="next-page"
              @click="getPage('next')"
						>
							<zt-icon name="arrow-right-outline" />
						</button>
					</div>
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import Eforms from "../../apiClient/Eforms";
import Folders from '../..//apiClient/Folders'
import tableCustom from "./tableCustom";
import VCalendar from "v-calendar";
import moment from "moment";
import { map, filter, flatten, flatMap } from 'lodash'
import { mapGetters } from "vuex";


export default {
  components: {
    tableCustom
  },
  data() {
    return {
      items: [],
      pagination: {
        page: 1,
        total: null,
        limit: 10,
      },
      sorting: {
        orderBy:null,
        orderType:'desc'
      },
      filtersContainer: false,
      foldersConfig: new Folders(),
      subFoldersEforms: [],
      autocompleteListSenders: [],
      autocompleteListTypeDocuments: [],
      userSenderSelected: {},
      typeDocumentsSelected: {},
      dateRangeFilter: {
        start: "",
        end: "",
      },
      dateRangeFilterFormat: {
        start: "",
        end: "",
      },
      dateRangeDisabled: false,
      listDocumentTypeSelected: '',
      listDocumentType: [],
      keySelect: 0,
      rangeFilterInput: '',
      menuDatePicker: false,
      parameters: {
        orders: {},
        filters: {}
      }
    };
  },
  created() {
    this.eforms = new Eforms();
    this.getPublishedEforms(this.pagination.limit, this.pagination.page);
    this.getSenders();
    this.getTypeDocuments();
  },
  methods: {
    getPublishedEforms(limit, page,params) {
      this.eforms
        .getPublishedEforms(limit, page,params)
        .then((response) => {
          if (response.status === 200) {
            this.items = response.data.data;
            this.pagination.total = response.data.pagination.total;
          }
        })
        .catch((error) => {});
    },
    getPage(pageRequest){
      const parameters = this.buildFilter();
      if (pageRequest === 'last' && this.pagination.page > 1) {
        this.pagination.page = this.pagination.page - 1
        this.getPublishedEforms(this.pagination.limit, this.pagination.page, parameters);
			}

			if (pageRequest === 'next') {
        this.pagination.page = this.pagination.page + 1
        this.getPublishedEforms(this.pagination.limit, this.pagination.page, parameters);
			}

    },
    reloadLimit() {
      this.getPublishedEforms(this.pagination.limit, this.pagination.page,"");
    },
    setReloadedNow(event){
      if(event){
        this.getPublishedEforms(this.pagination.limit, this.pagination.page, "");
      }
    },
    buildFilter() {
      let parameters = {}
      if (this.sorting.orderBy ) {
        this.parameters.orders.orderBy = this.sorting.orderBy;
      }
      if (this.sorting.orderType ) {
        this.sorting.orderType = this.sorting.orderType === 'desc' ? 'asc' : 'desc';
        this.parameters.orders.orderType = this.sorting.orderType;
      }

      if(this.userSenderSelected && this.userSenderSelected.value !== undefined){
        this.parameters.filters.sender = [this.userSenderSelected.value];
      }
      if(this.typeDocumentsSelected && this.typeDocumentsSelected.value !== undefined){
        this.parameters.filters.templateName = [this.typeDocumentsSelected.value];
      }
      if(this.dateRangeFilterFormat && this.dateRangeFilterFormat.start !== ""){
        this.parameters.filters.publishDateFrom = this.dateRangeFilterFormat.start;
        this.parameters.filters.publishDateTo = this.dateRangeFilterFormat.end;
      }

      return this.parameters
    },

    setSorting(order,type){
      this.sorting.orderBy = order;
      const parameters = this.buildFilter();
      this.getPublishedEforms(this.pagination.limit, this.pagination.page, parameters);

    },
    async getSenders(){
      this.eforms
        .getEformsSenders()
        .then((response) => {
          if (response.status === 200) {
            this.autocompleteListSenders = response.data.data.map((element) => {
              return {
                text: element.fullname,
                value: element.id,
              };
            });
          }
        })
        .catch((error) => {
        });
    },
    async getTypeDocuments(){
      try {
        const responseFolders = await this.foldersConfig.getFoldersAndEforms()

        const {
          data: { data }
        } = responseFolders

        this.subFoldersEforms = flatMap(filter(data, { type: 'eforms' }),
          subFolder => subFolder.childs
        )

        this.autocompleteListTypeDocuments = this.subFoldersEforms.filter(element => element.name !== null).map((element) => {
          return {
            text: this.$sanitize(element.name),
            value: element.id,
          };
        });
      } catch (error) {
        this.foldersItems = []
      }
    },
    autoCompleteOptionSelected(data) {
      this.userSenderSelected = data;
    },
    autoCompleteOptionTypeDocumentsSelected(data) {
      this.typeDocumentsSelected = data;
    },
    getPublishedEformsFilter(){
      const parameters = this.buildFilter();
      this.getResetPagination();
      this.getPublishedEforms(this.pagination.limit, 1, parameters);
    },
    cleanFilters(){
      this.$refs.ztAutocompleteSender.clearItemSelected();
      this.$refs.ztAutocompleteTypeDocuments.clearItemSelected();
      this.userSenderSelected = {}
      this.typeDocumentsSelected = {}
      this.dateRangeFilterFormat = {
        start: "",
        end: "",
      }
      this.dateRangeFilter = {
        start: "",
        end: "",
      }
      this.parameters = {
        orders: {},
        filters: {},
      }
      this.getResetPagination();
      this.getPublishedEforms(this.pagination.limit, this.pagination.page);
    },
    getResetPagination(){
      this.pagination = {
        page: 1,
        total: null,
        limit: 10,
      }
    }

  },
  computed: {
    ...mapGetters(["getUser"]),
    localeDatePicker() {
      return this.getUser.pais === 'BR' ? 'pt-br' : 'es'
    },
    dateSearchText() {
      let dateSearchText = "";

      if (this.dateRangeFilter && this.dateRangeFilter.start !== "") {
        let dateRangeFilterStart = moment(this.dateRangeFilter.start);
        let dateRangeFilterEnd = moment(this.dateRangeFilter.end);

        dateSearchText = `${dateRangeFilterStart.format("DD/MM/YYYY")} - ${dateRangeFilterEnd.format("DD/MM/YYYY")}`;
        this.dateRangeFilterFormat.start = dateRangeFilterStart.format("YYYY-MM-DD")
        this.dateRangeFilterFormat.end = dateRangeFilterEnd.format("YYYY-MM-DD")
      }

      if(this.$refs.ztInputCalendar){
        this.$refs.ztInputCalendar._data.textFieldValue = dateSearchText;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .select_result_page{
    border: none;
    appearance: auto;
  }
  button.button-filter {
    background-color: #ffffff;
    border: 1px solid #d6d6d6;
    color: #686868 !important;
    box-shadow: none;
    height: 2.94rem;
  }

  button.button-filter:hover {
    box-shadow: none;
  }

  button.button-filter-grey {
    background-color: #d6d6d6 !important;
  }

  ::v-deep button.button-filter {
    i.zt-icon-filter-amount {
      transition: transform 0.4s ease-in-out;
      transform: rotate(0deg);
    }
  }

  ::v-deep button.button-filter-grey {
    i.zt-icon-filter-amount {
      transition: transform 0.4s ease-in-out;
      transform: rotate(180deg);
    }
  }

  .wrapper-filters .actions ::v-deep .zt-button{
    height: auto;
  }

  .wrap-datepicker{
    position: relative;
    ::v-deep {
      .zt-input-main{
        .zt-input-text-field{
          .zt-label{
            margin: 0;
            background: #fff;
            padding: 2px 5px 0;
          }
        }
      }
      .v-menu{
        .v-menu__content{
          top: 52px !important;
          left: 0px !important;
          width: 100% !important;
          max-width: 100% !important;
          .vc-container{
            width: 100%;
          }
        }
      }
    }
  }

  .zt-autocomplete{
    height: 50px;
    padding: 0 12px;
    ::v-deep .zt-autocomplete-label{
      margin: 0;
      font-size: 14px;
    } 
  }

  .zt-input-focused ::v-deep fieldset{
    border: 1px solid #898dff; 
  }
</style>